import { useI18n } from "@wojo/localization";
import { Table, Text } from "@wojo/ui";
import { CanceledGroupMemberDetailsFragment } from "generated/graphql";
import React from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { TravelerContactInfo } from "../traveler-contact-info/TravelerContactInfo";

dayjs.extend(utc);

export type CanceledTravelersTableProps = {
    canceledTravelers: CanceledGroupMemberDetailsFragment[];
};

export const CanceledTravelersTable: React.FC<CanceledTravelersTableProps> = ({
    canceledTravelers,
}) => {
    const i18n =
        useI18n("account").account.myGroupMembers.canceledTravelersTable;

    return (
        <div
            style={{
                paddingBottom:
                    canceledTravelers.length === 1 ? 0 : "var(--g-spacing-xl)",
            }}
        >
            <Table
                header={
                    <Table.Header>
                        <Table.Cell>{i18n.nameHeader.l()}</Table.Cell>
                        <Table.Cell>{i18n.dateAddedHeader.l()}</Table.Cell>
                        <Table.Cell>{i18n.dateCanceledHeader.l()}</Table.Cell>
                        <Table.Cell>{i18n.contactInfoHeader.l()}</Table.Cell>
                    </Table.Header>
                }
                showTitle={false}
                tableTitle={
                    <Text.Heading
                        order="3"
                        style={{ paddingBottom: "var(--g-spacing-md)" }}
                    >
                        {i18n.tableTitle.l()}
                    </Text.Heading>
                }
            >
                {canceledTravelers.map((traveler) => {
                    const address = traveler.customer?.address ?? undefined;
                    const email = traveler.customer?.email ?? "";
                    const phoneNumber = traveler.customer?.phoneNumber ?? "";
                    return (
                        <Table.Row
                            key={traveler._id}
                            header={
                                <Table.Cell>
                                    <div
                                        style={{
                                            display: "flex",
                                        }}
                                    >
                                        <Text.Body variant="2" emphasis="2">
                                            {`${
                                                traveler.customer?.lastName ??
                                                ""
                                            },`}
                                            &nbsp;
                                        </Text.Body>
                                        <Text.Body variant="2">
                                            {traveler.customer?.firstName ?? ""}
                                        </Text.Body>
                                    </div>
                                </Table.Cell>
                            }
                        >
                            <Table.Cell>
                                <Text.Body variant="2">
                                    {dayjs
                                        .utc(traveler.dateBooked)
                                        .format("MMM D, YYYY")}
                                </Text.Body>
                            </Table.Cell>
                            <Table.Cell>
                                <Text.Body variant="2">
                                    {dayjs
                                        .utc(
                                            traveler.cancellationMeta
                                                ?.cancellationDate,
                                        )
                                        .format("MMM D, YYYY")}
                                </Text.Body>
                            </Table.Cell>
                            <Table.Cell>
                                <TravelerContactInfo
                                    address={address}
                                    phoneNumber={phoneNumber}
                                    email={email}
                                />
                            </Table.Cell>
                        </Table.Row>
                    );
                })}
            </Table>
        </div>
    );
};
